var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSerIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3343 4.74699V2.66699C22.3343 2.12033 21.8809 1.66699 21.3343 1.66699C20.7876 1.66699 20.3343 2.12033 20.3343 2.66699V4.66699H11.6676V2.66699C11.6676 2.12033 11.2143 1.66699 10.6676 1.66699C10.1209 1.66699 9.66761 2.12033 9.66761 2.66699V4.74699C6.06761 5.08032 4.32096 7.22699 4.05429 10.4137C4.02762 10.8003 4.34762 11.1203 4.72096 11.1203H27.2809C27.6676 11.1203 27.9876 10.787 27.9476 10.4137C27.6809 7.22699 25.9343 5.08032 22.3343 4.74699Z",
    fill: "#090129"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M26.6667 13.1201C27.4 13.1201 28 13.7201 28 14.4535V22.6668C28 26.6668 26 29.3335 21.3333 29.3335H10.6667C6 29.3335 4 26.6668 4 22.6668V14.4535C4 13.7201 4.6 13.1201 5.33333 13.1201H26.6667Z",
    fill: "#090129"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7872 19.9866L19.1206 20.6666H19.1072L15.0672 24.7066C14.8939 24.8799 14.5339 25.0666 14.2806 25.0933L12.4806 25.3599C11.8272 25.4532 11.3739 24.9866 11.4673 24.3466L11.7206 22.5332C11.7606 22.2799 11.9339 21.9332 12.1072 21.7466L16.1606 17.7066L16.8272 17.0266C17.2672 16.5866 17.7606 16.2666 18.2939 16.2666C18.7472 16.2666 19.2406 16.4799 19.7872 17.0266C20.9872 18.2266 20.6006 19.1732 19.7872 19.9866Z",
    fill: "#090129"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerIcon2);
export default __webpack_public_path__ + "static/media/ser-icon-2.4783f7639dd5d3841816190a50c9d01d.svg";
export { ForwardRef as ReactComponent };